import React, { Component } from 'react';
import Screensaver from './Screensaver.jsx';
import ScreensaverInfo from './ScreensaverInfo.jsx';
import Draggable from 'react-draggable';
const ESCAPE_KEY = 27;
import './ScreensaverContainer.css';

export default class ScreensaverContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showScreensaver: false,
      screensaverText: 'Windows XP',
      checked: 'default',
      sizeMultiplier: 1,
      speedMultiplier: 1,
      showInfo: false,
    };
    this.handleCustomTextInput = this.handleCustomTextInput.bind(this);
    this.startScreensaver = this.startScreensaver.bind(this);
    this.hideScreensaver = this.hideScreensaver.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    // this.handleMouseMove = this.handleMouseMove.bind(this);
    this.showInfoDialog = this.showInfoDialog.bind(this);
    this.hideInfoDialog = this.hideInfoDialog.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handleSpeedChange = this.handleSpeedChange.bind(this);
  }

  componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener('mousemove', this.handleMouseMove, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener('mousemove', this.handleMouseMove, false);
  }

  // handleMouseMove() {
  //   // document.removeEventListener('mousemove', this.handleMouseMove, false);
  //   if (this.state.showScreensaver) {
  //     this.setState({
  //       showScreensaver: false
  //     });
  //   }
  // }


  handleCustomTextInput(e) {
    const text = e.target.value;
    this.setState ({
      screensaverText: text,
      checked: 'custom',
    });
  }

  handleKeyDown (event) {
    switch( event.keyCode ) {
      case ESCAPE_KEY:
        event.preventDefault();
        this.setState({
          showScreensaver: false
        });
        break;
      default:
        break;
    }
  }

  showInfoDialog() {
    this.setState({
      showInfo: true
    });
  }

  hideInfoDialog() {
    this.setState({
      showInfo: false
    })
  }

  startScreensaver() {
    this.setState({
      showScreensaver: true
    })
  }

  hideScreensaver() {
    this.setState({
      showScreensaver: false
    })
  }

  handleRadioChange(e) {
    if (e.currentTarget.value === 'default') {
      this.setState({
        checked: 'default',
        screensaverText: 'Windows XP',
      });
    }
    else {
      this.setState({
        checked: 'custom',
      });
    }
  }

  handleSizeChange(e) {
    this.setState({
      sizeMultiplier: (Number(e.currentTarget.value) + 1) / 51,
    });
  }

  handleSpeedChange(e) {
    this.setState({
      speedMultiplier: (Number(e.currentTarget.value) + 1) / 51,
    });
  }

  render () {
    const {
      showScreensaver,
      screensaverText,
      sizeMultiplier,
      speedMultiplier,
      showInfo,
    } = this.state;

    return (
      <div className="screensaver-background">
        <Draggable bounds='parent' handle=".screensaver-dialog-header">
          <div className="screensaver-settings-dialog">
            <div className="screensaver-dialog-header">
              3D Text Screensaver Settings
              <div className="screensaver-dialog-header-action screensaver-dialog-help"
                onClick={this.showInfoDialog}>
                ?
              </div>
            </div>
            <div className="screensaver-dialog-body">
              <div className="screensaver-dialog-container">
                <div className="screensaver-dialog-container-header">
                  Text
                </div>
                <div className="screensaver-input-container">
                  <input type="radio"
                    name="text-value"
                    value="default"
                    id="text-value-time"
                    checked={this.state.checked === 'default'}
                    onChange={this.handleRadioChange} />
                  <label htmlFor="text-value-time"> Default Text</label><br />
                  <input
                    type="radio"
                    name="text-value"
                    value="custom"
                    id="text-custom-value"
                    checked={this.state.checked === 'custom'}
                    onChange={this.handleRadioChange} />
                  <label htmlFor="text-custom-value"> Custom Text:</label>
                  <input type="text" className="screensaver-custom-text-input"
                    onChange={this.handleCustomTextInput}/>
                </div>
              </div>
              <div className="half-slider-container">
                <div className="screensaver-dialog-container half-slider">
                  <div className="screensaver-dialog-container-header">
                    Size
                  </div>
                  <div className="screensaver-input-container">
                    <div className="range-label-left">
                      Small
                    </div>
                    <div className="range-label-right">
                      Large
                    </div>
                    <input type="range"
                      onChange={this.handleSizeChange} />
                  </div>
                </div>
                <div className="screensaver-dialog-container half-slider">
                  <div className="screensaver-dialog-container-header">
                    Speed
                  </div>
                  <div className="screensaver-input-container">
                    <div className="range-label-left">
                      Slow
                    </div>
                    <div className="range-label-right">
                      Fast
                    </div>
                    <input type="range"
                      onChange={this.handleSpeedChange} />
                  </div>
                </div>
              </div>
              <div className="screensaver-dialog-button-container">
                <div className="screensaver-dialog-button"
                  onClick={this.startScreensaver}>
                  Preview
                </div>
              </div>
            </div>
          </div>
        </Draggable>
        {showScreensaver
          ? <Screensaver
              hideScreensaver={this.hideScreensaver}
              text={screensaverText}
              sizeMultiplier={sizeMultiplier}
              speedMultiplier={speedMultiplier} />
          : null}
        {showInfo
          ? <ScreensaverInfo
              hideInfoDialog={this.hideInfoDialog}/>
          : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/screensaver/ScreensaverContainer.jsx